export const environment = {
  name: 'production',
  faxeServiceRootUrl: 'https://hsr.azurewebsites.net',
  faxeChatHub: 'https://hsr.azurewebsites.net/hubs/ChatHub/',
  production: true,
  enableServiceWorker: true
};
